import {
  ExtractFnReturnType,
  InfiniteQueryConfigType,
  useInfiniteQuery,
  UseInfiniteQueryResult,
} from "~/libs";

import { ApiClient } from "~/utils";

import { ApiMembersDirectMessageRoomsShowResponseType } from "~/domains";

type RequestDataType = {
  employeeId: string;
  page?: number;
};

const request = async ({
  employeeId,
  page = 1,
}: RequestDataType): Promise<ApiMembersDirectMessageRoomsShowResponseType> => {
  const response =
    await new ApiClient().get<ApiMembersDirectMessageRoomsShowResponseType>(
      `/api/members/employees/${employeeId}/direct_message_rooms`,
      { page },
    );
  return response.data;
};

type QueryFnType = typeof request;

type PropsType = {
  employeeId: string;
  config?: InfiniteQueryConfigType<QueryFnType>;
};

export const useApisMembersEmployeesDirectMessageRoomsShow = ({
  employeeId,
  config = {},
}: PropsType): UseInfiniteQueryResult<ApiMembersDirectMessageRoomsShowResponseType> => {
  return useInfiniteQuery<ExtractFnReturnType<QueryFnType>>(
    ["ApisMembersEmployeesDirectMessageRoomsShow", employeeId],
    ({ pageParam }) => {
      return request({ employeeId, page: pageParam as number | undefined });
    },
    {
      ...config,
      getNextPageParam: (data) => {
        return data.pagy.hasMore ? data.pagy.currentPage + 1 : false;
      },
    },
  );
};
